<!--
  Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div>
  <button *ngIf="!isMenuItem"
          (click)="showConfirmationDialog()" [disabled]="disabled" class="update-button"
          color="primary" id="update-with-seg-scheme-button"
          mat-raised-button>
    Update with Segment Scheme
  </button>
  <button *ngIf="isMenuItem" (click)="showConfirmationDialog()" [disabled]="disabled"
          id="update-with-seg-scheme-menu-item"
          mat-menu-item>
    Update with Segment Scheme
  </button>
</div>
